import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicUtilisationFiltres = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Rechercher et s'inscrire", link: '/topics/rechercher'},
    { label: 'Rechercher des conseils', link: '/topics/rechercher/recherche-conseils'},
    { label: topic.title, link: topic.link},
  ]

// <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/competitions`}>des compétitions</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Parfois, on souhaite simplement parcourir le site. D'autres fois, on sait exactement ce que l'on recherche. Les filtres de recherche sont un 
              excellent moyen d'affiner les résultats lorsque vous recherchez une compétition. Si vous disposez d'une certaine flexibilité, vous pouvez choisir 
              des plages de dates et des tags très spécifiques pour vous aider à cibler
              <a target='_blank' className="link" href={`/topics/inscription/26`}>votre recherche.</a>
            </p>
            {/* <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/> */}
            <div className="article-container mt-40">
              <p className="help-title-part">{topic.subtitles[0]}</p>
              <p className="help-text">
                Sélectionnez Filtres pour affiner votre recherche. Choisissez parmi les nombreux filtres ceux qui s'appliquent le mieux à la compétition recherchée.
              </p>
            </div>
            <div className="article-container mt-24">
              <p className="help-text mb-6"><strong>Format de l'êvenement</strong></p>
              <p className="help-text">Il s'agit du format global de l'event : </p>
              <ul>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    sur place, en ligne ? indiv, team ?
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <strong>Draft</strong> désigne un mode de sélection des équipes au tour par tour, inspiré de la NBA ou des cours de récréation. 
                    Parmi la liste de tous les inscrits, les capitaines choisissent leurs coéquipiers un par un. Ensuite, l’organisateur de l’événement, via 
                    son profil Admin, finalisera la composition des équipes dans lesquelles vous serez réparti.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <strong>Tri au ranking</strong> : Tous les participants s’inscrivent dans une catégorie (par exemple, Homme/Homme). Un ou plusieurs WODs sont 
                    réalisés pour établir un classement initial. Ensuite, en fonction du leaderboard, les athlètes sont répartis dans différentes catégories. 
                    Par exemple, les x premiers intègrent la catégorie RX, les x suivants la catégorie Inter, et les derniers la catégorie Scale.
                  </p>
                </li>
              </ul>
            </div>
            <div className="article-container mt-40">
              <p className="help-text mb-6"><strong>Fourchette de prix</strong></p>
              <p className="help-text">Trouvez l'event adapté à votre budget en filtrant les résultats selon le prix.</p>
            </div>
            <div className="article-container mt-40">
              <p className="help-text mb-6"><strong>Zone géographique</strong></p>
              <p className="help-text">Cliquez sur une région de France pour filtrer les compétitions disponibles, représentées par des points rouges sur la carte.</p>
            </div>
            <div className="article-container mt-40">
              <p className="help-text mb-6"><strong>Quand se déroule l'êvenement</strong></p>
              <p className="help-text">
                Choisissez une période : une compétition passée, en cours, ou à venir. Si vous recherchez un mois précis, cliquez simplement sur les mois qui 
                vous intéressent. Pour afficher tous les mois de l’année, cliquez sur Afficher plus.
              </p>
            </div>
            <div className="article-container mt-40">
              <p className="help-text mb-6"><strong>Éléments d'accessibilité</strong></p>
              <p className="help-text">
                Certaines annonces de compétitions sont publiées, mais l’inscription peut ne pas être disponible. Cela peut être dû à des inscriptions pas encore ouvertes, 
                à un manque de places libres, ou à une date limite dépassée. En activant l’option Uniquement les events avec inscriptions ouvertes, vous verrez uniquement 
                les compétitions pour lesquelles vous pouvez encore vous inscrire.
              </p>
            </div>
            <div className="article-container mt-40">
              <p className="help-text mb-6"><strong>Tags</strong></p>
              <p className="help-text">
                Certaines athlètes préfèrent travailler en équipe de 3, d'autres préfère se challenger en solo, ou bien encore à la recherche d'un cash prize. 
                Recherchez ce dont vous avez besoin parmi toutes les options disponibles. Vous pouvez bien sûr en sélectionner plusieurs.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicUtilisationFiltres